import {Injectable} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SessionService} from './session.service';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

    constructor(private session: SessionService, private router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.session.getBearerToken();
        if (token) {
            req = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${this.session.getBearerToken()}`)
            });
        }
        return next.handle(req).pipe(tap(() => {
            },
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 401) {
                        return;
                    }
                    localStorage.clear();
                    sessionStorage.clear();
                    this.router.navigateByUrl('/login');
                }
            }));
    }
}

export const authInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true}
];
